import { GOOGLE_PLAY_APP_URL, GOOGLE_PLAY_PACKAGE_ID } from '@/constants';

/**
 * Abre a ficha do app na Google Play.
 * Em Android usa `market://` para priorizar o app da Play Store; nos demais casos abre a URL HTTPS em nova aba.
 */
export function openGooglePlayListing(): void {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  const isAndroid = /Android/i.test(navigator.userAgent);
  if (isAndroid) {
    window.location.assign(`market://details?id=${GOOGLE_PLAY_PACKAGE_ID}`);
    return;
  }
  window.open(GOOGLE_PLAY_APP_URL, '_blank', 'noopener,noreferrer');
}
